import "./App.css";
import { useMemo } from "react";

import Minter from "./Minter";

import * as anchor from "@project-serum/anchor";
import { clusterApiUrl } from "@solana/web3.js";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import {
  getPhantomWallet,
  getSolflareWallet,
  getSolletWallet,
  getMathWallet,
} from "@solana/wallet-adapter-wallets";

import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";

import { WalletDialogProvider } from "@solana/wallet-adapter-material-ui";
import { ThemeProvider, createTheme } from "@material-ui/core";


const theme = createTheme({
  palette: {
    type: "dark",
  },
});

const candyMachineId = process.env.REACT_APP_CANDY_MACHINE_ID
  ? new anchor.web3.PublicKey(process.env.REACT_APP_CANDY_MACHINE_ID)
  : undefined;

const network = process.env.REACT_APP_SOLANA_NETWORK as WalletAdapterNetwork;

const rpcHost = process.env.REACT_APP_SOLANA_RPC_HOST!;
const connection = new anchor.web3.Connection(rpcHost);

const startDateSeed = parseInt(process.env.REACT_APP_CANDY_START_DATE!, 10);

const txTimeout = 30000; // milliseconds (confirm this works for your project)

const App = () => {
  const endpoint = useMemo(() => clusterApiUrl(network), []);

  const wallets = useMemo(
    () => [getPhantomWallet(), getSolflareWallet(), getSolletWallet(), getMathWallet() ],
    []
  );

  function toggleMenu() {
    const menu = document.getElementById("mobileNavContainer")!;
    menu.classList.toggle("open-menu");
    console.log("pressed");
  }

  return (
    <div>
      <div id="mobileNavContainer" className="mobile-nav">
        <div className="mobile-nav-close-button" >
          <img src="/icons/close.svg" alt="" onClick={toggleMenu}/>
        </div>
        <ul>
          <li>
            <img className="mobile-nav-logo" src="/img/ValDAO.png" alt="Valentine DAO Logo" />
          </li>
          {/* <li>
            <a href="/#link1" onClick={toggleMenu}>
              Link 1
            </a>
          </li>
          <li>
            <a href="/#link2" onClick={toggleMenu}>
              Link 2
            </a>
          </li>
          <li>
            <a href="/#link3" onClick={toggleMenu}>
              Link 3
            </a>
          </li>
          <li>
            <a href="/#link4" onClick={toggleMenu}>
              Link 4
            </a>
          </li> */}
          <li>
            <div className="social-icons">
              <a href="https://www.twitter.com/BluntDAO" target="_blank" rel="noopener noreferrer">
                <img className="nav-social" src="/icons/twitter.svg" alt="Twitter Logo" />
              </a>
              <a href="https://discord.gg/e3cGSTzyWp" target="_blank" rel="noopener noreferrer">
                <img className="nav-social" src="/icons/discord.svg" alt="Discord Logo" />
              </a>
              {/* <a href="https://linktr.ee/BluntDAO" target="_blank" rel="noopener noreferrer">
              <img className="nav-social" src="/icons/WeedGlobe.svg" alt="Link Logo" />
            </a> */}
            </div>
          </li>
        </ul>
      </div>
      <div className="mobile-menu-button" onClick={toggleMenu}>
        <img src="/icons/menu.svg" alt="Menu Button" />
      </div>
      <nav>
        <div className="nav-container">
          <img className="nav-logo" src="/img/ValDAO.png" alt="Valetine DAO Logo" />
          {/* <a className="hide-800" href="/#link1">
            Link 1
          </a>
          <a className="hide-800" href="/#link2">
            Link 2
          </a>
          <a className="hide-800" href="/#link3">
            Link 3
          </a>
          <a className="hide-800" href="/#link4">
            Link 4
          </a> */}
          <div className="social-icons hide-800">
            <a href="https://www.twitter.com/BluntDAO" target="_blank" rel="noopener noreferrer">
              <img className="nav-social" src="/icons/twitter.svg" alt="Twitter Logo" />
            </a>
            <a href="https://discord.gg/e3cGSTzyWp" target="_blank" rel="noopener noreferrer">
              <img className="nav-social" src="/icons/discord.svg" alt="Discord Logo" />
            </a>
            {/* <a href="https://linktr.ee/BluntDAO" target="_blank" rel="noopener noreferrer">
              <img className="nav-social" src="/icons/WeedGlobe.svg" alt="Link Logo" />
            </a> */}
          </div>
        </div>
      </nav>
      <div className="content-wrapper">
          <header className="card" id="link1">
            <div style={{ padding: "0 24px 0 24px 0" }}>
              {/* <h3 className="text-secondary-color">Join the</h3> */}
              <h1 className="pb-3">❤️ValentineDAO❤️</h1>
              <p className="text-secondary-color">
              onboards your loved ones to Web3, one valentine card nft at a time ♡ ♥💕❤😘
              </p>
            </div>
            <div>
              <ThemeProvider theme={theme}>
                <ConnectionProvider endpoint={endpoint}>
                  <WalletProvider wallets={wallets} autoConnect>
                    <WalletDialogProvider>
                      
                        <Minter
                          candyMachineId={candyMachineId}
                          
                          connection={connection}
                          startDate={startDateSeed}
                          txTimeout={txTimeout}
                          rpcHost={rpcHost}
                        />
                      
                    </WalletDialogProvider>
                  </WalletProvider>
                </ConnectionProvider>
              </ThemeProvider>
            </div>
          </header>

          {/* <div id="link2" className="container">
            BluntDAO
          </div> */}

          {/* <div id="link3" className="container card">
            <h1 className="pb-3"> 🍃BluntDAO🍃 will onboard the next 1 million blunt enthusiasts onto the decentralized Web
</h1>
          </div> */}
{/* 
          <div id="link4" className="container faq">
            <h1 style={{ padding: "0 0 24px 0" }}>FAQ</h1>
            <div>
              <h4>What blockchain is BluntDAO on?</h4>
              <p>
                The BluntDAO is on the Solana blockchain.
              </p>

              <hr />
            </div>

            <div>
              <h4>When is the mint date?</h4>
              <p>
                The mint is live on bluntdao.com right now
              </p>

              <hr />
            </div>
            <div>
              <h4>How do I join the BluntDAO?</h4>
              <p>
              You join the BluntDAO by officially sesh'ing with DAO member via Proof of Sesh, Boof of Stake consensys.
              </p>

              <hr />
            </div>
            <div>
              <h4>I still have a question not answered in this FAQ, how can I find out?</h4>
              <p>
              Head over to the ❓-support channel on Discord. We will make sure to address any additional questions you may have as soon as possible!
              </p>

              <hr />
            </div>
          </div> */}
      </div>
    </div>
  );
};

export default App;
